import React, { useState } from "react";
import DataParser from "../../utlits/Dataparser";
import moment from "moment";
import { DatePicker } from "antd";
import { useEffect } from "react";

const DateField = (props) => {
  const { item, Services, data, defaultDate, format } = props;
  const [date, setDate] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const dateFormat = format || "DD-MM-YYYY";

  const onDateChange = (date, dateString) => {
    setIsOpen(false); // Force close immediately
    if (!date) return;

    setDate(date); // Store local moment object for immediate UI responsiveness

    const id = item.id;
    const companyId = DataParser.CompanyId();
    const companyIdentifier = DataParser.CompanyIdentifier();
    const dateSentStr = date.format("YYYY-MM-DD");

    const dateSent = {
      company_id: companyId,
      company_identifier: companyIdentifier,
      duedate: dateSentStr,
    };

    Services(id, dateSent).then((res) => {
      if (res.Good) {
        data(dateSentStr);
      }
    });
  };
  return (
    <>
    <div style={{ fontSize: props.styles?.fontSize || 'inherit', width: '100%' }} className="date-field-wrapper">
      <style>{`
        .date-field-wrapper .ant-picker-input > input {
          font-size: inherit !important;
          font-weight: 500 !important;
          color: ${props.styles?.color || '#404e67'} !important;
        }
        .date-field-wrapper .ant-picker {
          padding: 0 !important;
        }
      `}</style>
      <DatePicker
        disabledDate={(current) => {
          const isBeforeToday = current && current < moment().startOf('day');
          const isAfterMax = props.maxDate && current && current.isAfter(moment(props.maxDate).endOf('day'));
          return isBeforeToday || isAfterMax;
        }}
        allowClear={false}
        bordered={false}
        value={date || (defaultDate ? moment(defaultDate) : null)}
        onChange={onDateChange}
        open={isOpen}
        onOpenChange={(status) => setIsOpen(status)}
        format={dateFormat}
        suffixIcon={props.hasOwnProperty('suffixIcon') ? props.suffixIcon : <i className="uil-calendar-alt" style={{ fontSize: "inherit", color: "#adb5bd", position: "relative", top: "1px" }} />}
        style={props.styles}
        disabled={props.disabled}
        dateRender={(current) => {
          const history = item?.follow_up_history || [];
          const isHistory = history.some(date => moment(date).isSame(current, 'day'));
          
          if (isHistory) {
              return (
                  <div className="ant-picker-cell-inner" style={{ 
                      border: '1px solid #0DDFAB', 
                      borderRadius: '50%', 
                      backgroundColor: 'rgba(13, 223, 171, 0.1)',
                      color: '#0DDFAB',
                      fontWeight: 'bold'
                  }}>
                      {current.date()}
                  </div>
              );
          }
          return <div className="ant-picker-cell-inner">{current.date()}</div>;
        }}
      />
    </div>
    </>
  );
};

export default DateField;
